/**
 * Concept B ATC flow:
 * confirmation bottom sheet → full cart drawer (shipping, upsells, trust)
 */
(function () {
  'use strict';

  var settings = (window.theme && theme.cartDrawerSettings) || {};
  if (!settings.enabled) return;

  var confirmRoot = document.getElementById('atc-confirm');
  var errorRoot = document.getElementById('atc-error');
  var drawerRoot = document.getElementById('cart-drawer');
  if (!confirmRoot || !drawerRoot) return;

  var confirmTimeout = null;
  var errorTimeout = null;
  var lastFocus = null;
  var CONFIRM_AUTO_MS = 8000;
  var ERROR_AUTO_MS = 8000;

  function formatMoney(cents) {
    var format = settings.moneyFormat || (theme && theme.moneyFormat) || '${{amount}}';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var html = theme.Currency.formatMoney(cents, format);
      var tmp = document.createElement('div');
      tmp.innerHTML = String(html);
      return (tmp.textContent || tmp.innerText || '').trim();
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function formatVariant(title) {
    if (!title || title === 'Default Title') return '';
    return String(title).replace(/\s*\/\s*/g, ' | ');
  }

  function thumbUrl(src) {
    if (!src) return '';
    return String(src).replace(/(\.[^\.]*$|$)/, '_small$1');
  }

  function cartCount() {
    if (window.CartJS && CartJS.cart && typeof CartJS.cart.item_count === 'number') {
      return CartJS.cart.item_count;
    }
    return 0;
  }

  function cartTotal() {
    if (window.CartJS && CartJS.cart && typeof CartJS.cart.total_price === 'number') {
      return CartJS.cart.total_price;
    }
    return 0;
  }

  function getLineQuantity(line) {
    if (!window.CartJS || !CartJS.cart || !CartJS.cart.items) return 1;
    var item = CartJS.cart.items[line - 1];
    return item ? item.quantity : 1;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function rememberCompareAt(variantId, compareAt) {
    if (!window.theme) window.theme = {};
    if (!theme.variantCompareAt) theme.variantCompareAt = {};
    if (variantId == null) return;
    if (compareAt != null && compareAt > 0) {
      theme.variantCompareAt[variantId] = compareAt;
      theme.variantCompareAt[String(variantId)] = compareAt;
    }
  }

  function seedCompareAtFromDom() {
    if (!window.theme) window.theme = {};
    if (!theme.variantCompareAt) theme.variantCompareAt = {};

    document.querySelectorAll('.product-card__data').forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        (data.variants || []).forEach(function (v) {
          rememberCompareAt(v.id, v.compare_at_price);
        });
      } catch (e) { /* ignore bad card JSON */ }
    });

    document.querySelectorAll('[id^="ProductJson-"]').forEach(function (script) {
      try {
        var product = JSON.parse(script.textContent);
        (product.variants || []).forEach(function (v) {
          rememberCompareAt(v.id, v.compare_at_price);
        });
      } catch (e) { /* ignore bad product JSON */ }
    });
  }

  function getCompareAt(item) {
    if (!item) return 0;
    if (item.compare_at_price != null && item.compare_at_price > 0) {
      return item.compare_at_price;
    }
    var map = (window.theme && theme.variantCompareAt) || {};
    var value = map[item.id];
    if (value == null) value = map[String(item.id)];
    return value > 0 ? value : 0;
  }

  function formatSalePriceHtml(priceCents, compareAtCents) {
    var price = formatMoney(priceCents);
    if (compareAtCents && compareAtCents > priceCents) {
      return (
        '<s class="cart-drawer__compare-price">' + escapeHtml(formatMoney(compareAtCents)) + '</s> ' +
        '<span class="cart-drawer__sale-price">' + escapeHtml(price) + '</span>'
      );
    }
    return escapeHtml(price);
  }

  function fetchCompareAtForItem(item, done) {
    if (!item || getCompareAt(item) > 0) {
      if (typeof done === 'function') done(getCompareAt(item));
      return;
    }

    var handle = item.handle;
    if (!handle && item.url) {
      var match = String(item.url).match(/\/products\/([^/?#]+)/);
      handle = match ? match[1] : null;
    }
    if (!handle) {
      if (typeof done === 'function') done(0);
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) {
          if (typeof done === 'function') done(0);
          return;
        }
        product.variants.forEach(function (v) {
          rememberCompareAt(v.id, v.compare_at_price);
        });
        if (typeof done === 'function') done(getCompareAt(item));
      })
      .catch(function () {
        if (typeof done === 'function') done(0);
      });
  }

  function renderCartItems() {
    var listEl = drawerRoot.querySelector('[data-cart-drawer-items]');
    var emptyEl = drawerRoot.querySelector('[data-cart-drawer-empty]');
    var footerEl = drawerRoot.querySelector('[data-cart-drawer-footer]');
    var trustEl = drawerRoot.querySelector('[data-cart-drawer-trust]');
    var subtotalEl = drawerRoot.querySelector('[data-cart-drawer-subtotal]');
    if (!listEl) return;

    var items = (window.CartJS && CartJS.cart && CartJS.cart.items) || [];
    var count = cartCount();
    var hasItems = count > 0 && items.length > 0;

    listEl.innerHTML = '';

    if (hasItems) {
      items.forEach(function (item, index) {
        var line = index + 1;
        var title = item.product_title || item.title || '';
        var variant = formatVariant(item.variant_title);
        var img = thumbUrl(item.image);
        var url = item.url || '#';
        var priceCents = item.final_price != null ? item.final_price : item.price;
        var compareAt = getCompareAt(item);
        var priceHtml = formatSalePriceHtml(priceCents, compareAt);
        var li = document.createElement('li');
        li.className = 'cart-drawer__item';
        li.setAttribute('data-cart-drawer-line', String(line));
        if (item.id != null) li.setAttribute('data-variant-id', String(item.id));
        if (item.product_id != null) li.setAttribute('data-product-id', String(item.product_id));
        li.innerHTML =
          '<a class="cart-drawer__item-img-link" href="' + escapeHtml(url) + '">' +
            '<img class="cart-drawer__item-img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" width="72" height="72" />' +
          '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a class="cart-drawer__item-title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>' +
            (variant ? '<p class="cart-drawer__item-variant">' + escapeHtml(variant) + '</p>' : '') +
            '<p class="cart-drawer__item-price">' + priceHtml + '</p>' +
            '<div class="cart-drawer__item-actions">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty="minus" aria-label="Decrease quantity">−</button>' +
                '<span class="cart-drawer__qty-val">' + escapeHtml(item.quantity) + '</span>' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty="plus" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove aria-label="Remove item">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
                  '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
          '</div>';
        listEl.appendChild(li);

        if (!compareAt) {
          fetchCompareAtForItem(item, function (resolved) {
            if (!resolved || resolved <= priceCents) return;
            var priceEl = li.querySelector('.cart-drawer__item-price');
            if (priceEl) priceEl.innerHTML = formatSalePriceHtml(priceCents, resolved);
          });
        }
      });
    }

    listEl.hidden = !hasItems;
    if (emptyEl) emptyEl.hidden = hasItems;
    if (footerEl) footerEl.hidden = !hasItems;
    if (trustEl) trustEl.hidden = !hasItems;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cartTotal());
  }

  function updateShippingBar() {
    var wrap = drawerRoot.querySelector('[data-cart-drawer-shipping]');
    if (!wrap) return;

    if (settings.showFreeShippingBar === false) {
      wrap.hidden = true;
      return;
    }

    var threshold = Number(settings.freeShippingThreshold) || 10000;
    var total = cartTotal();
    var remaining = Math.max(0, threshold - total);
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;

    var msgEl = drawerRoot.querySelector('[data-cart-drawer-shipping-msg]');
    var fillEl = drawerRoot.querySelector('[data-cart-drawer-shipping-fill]');
    var barEl = drawerRoot.querySelector('[data-cart-drawer-shipping-bar]');

    if (!msgEl || !fillEl) return;

    if (cartCount() < 1) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;

    if (remaining <= 0) {
      msgEl.textContent = "You've unlocked FREE shipping!";
    } else {
      msgEl.textContent = "You're " + formatMoney(remaining) + ' away from FREE shipping!';
    }

    fillEl.style.width = pct + '%';
    if (barEl) barEl.setAttribute('aria-valuenow', String(Math.round(pct)));
  }

  function updateUpsellVisibility() {
    var cards = drawerRoot.querySelectorAll('[data-upsell-card]');
    if (!cards.length || !window.CartJS || !CartJS.cart) return;

    var inCart = {};
    (CartJS.cart.items || []).forEach(function (item) {
      inCart[String(item.product_id)] = true;
      inCart[String(item.id)] = true;
    });

    var visible = 0;
    cards.forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      var vid = card.getAttribute('data-variant-id');
      var hide = !!(inCart[pid] || inCart[vid]);
      card.hidden = hide;
      if (!hide) visible += 1;
    });

    var upsell = drawerRoot.querySelector('[data-cart-drawer-upsell]');
    if (upsell) upsell.hidden = visible === 0 || cartCount() < 1;
  }

  function refreshDrawerChrome(options) {
    options = options || {};
    renderCartItems();
    updateShippingBar();
    updateUpsellVisibility();
    if (options.highlightVariantId) {
      highlightCartLine(options.highlightVariantId);
    }
  }

  function highlightCartLine(variantId) {
    if (!variantId) return;
    var line = drawerRoot.querySelector(
      '.cart-drawer__item[data-variant-id="' + String(variantId) + '"]'
    );
    if (!line) return;

    line.classList.remove('is-highlighted');
    // Force reflow so re-adding the class restarts the animation.
    void line.offsetWidth;
    line.classList.add('is-highlighted');

    var listEl = drawerRoot.querySelector('[data-cart-drawer-items]');
    if (listEl && typeof line.scrollIntoView === 'function') {
      line.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    window.setTimeout(function () {
      line.classList.remove('is-highlighted');
    }, 1400);
  }

  function markUpsellAdded(btn) {
    if (!btn) return;
    btn.classList.add('is-added');
    btn.setAttribute('aria-label', 'Added to cart');
    btn.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function openConfirm(item, addedQty) {
    closeError(true);
    closeDrawer(true);
    clearTimeout(confirmTimeout);

    var img = confirmRoot.querySelector('[data-atc-confirm-img]');
    var name = confirmRoot.querySelector('[data-atc-confirm-name]');
    var variant = confirmRoot.querySelector('[data-atc-confirm-variant]');
    var price = confirmRoot.querySelector('[data-atc-confirm-price]');
    var qtyEl = confirmRoot.querySelector('[data-atc-confirm-qty]');
    var count = confirmRoot.querySelector('[data-atc-confirm-count]');
    var qtyAdded = parseInt(addedQty, 10);
    if (isNaN(qtyAdded) || qtyAdded < 1) qtyAdded = 1;

    if (img) {
      img.src = thumbUrl(item.image);
      img.alt = item.product_title || '';
    }
    if (name) name.textContent = item.product_title || item.title || '';
    if (variant) {
      var v = formatVariant(item.variant_title);
      variant.textContent = v;
      variant.hidden = !v;
    }
    if (price) {
      var priceCents = item.final_price != null ? item.final_price : item.price;
      var compareAt = getCompareAt(item);
      price.innerHTML = formatSalePriceHtml(priceCents, compareAt);
      if (!compareAt) {
        fetchCompareAtForItem(item, function (resolved) {
          if (!resolved || resolved <= priceCents) return;
          price.innerHTML = formatSalePriceHtml(priceCents, resolved);
        });
      }
    }
    if (qtyEl) {
      qtyEl.textContent = qtyAdded === 1 ? 'Qty: 1' : 'Qty: ' + qtyAdded + ' added';
    }
    if (count) count.textContent = String(cartCount() || item.quantity || qtyAdded);

    lastFocus = document.activeElement;
    confirmRoot.hidden = false;
    confirmRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('atc-confirm-open');

    requestAnimationFrame(function () {
      confirmRoot.classList.add('is-open');
    });

    confirmTimeout = setTimeout(closeConfirm, CONFIRM_AUTO_MS);
  }

  function closeConfirm(skipFocus) {
    clearTimeout(confirmTimeout);
    confirmRoot.classList.remove('is-open');
    document.body.classList.remove('atc-confirm-open');
    confirmRoot.setAttribute('aria-hidden', 'true');

    setTimeout(function () {
      confirmRoot.hidden = true;
      if (!skipFocus && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, 280);
  }

  function openError(message) {
    if (!errorRoot) {
      window.alert(message || 'Unable to add to cart');
      return;
    }

    closeConfirm(true);
    closeDrawer(true);
    clearTimeout(errorTimeout);

    var msgEl = errorRoot.querySelector('[data-atc-error-msg]');
    if (msgEl) {
      msgEl.textContent = message || 'Unable to add to cart';
    }

    lastFocus = document.activeElement;
    errorRoot.hidden = false;
    errorRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('atc-confirm-open');

    requestAnimationFrame(function () {
      errorRoot.classList.add('is-open');
    });

    errorTimeout = setTimeout(function () {
      closeError();
    }, ERROR_AUTO_MS);
  }

  function closeError(skipFocus) {
    if (!errorRoot) return;
    clearTimeout(errorTimeout);
    errorRoot.classList.remove('is-open');
    if (!confirmRoot.classList.contains('is-open')) {
      document.body.classList.remove('atc-confirm-open');
    }
    errorRoot.setAttribute('aria-hidden', 'true');

    setTimeout(function () {
      errorRoot.hidden = true;
      if (!skipFocus && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, 280);
  }

  function openDrawer() {
    closeConfirm(true);
    closeError(true);
    clearTimeout(confirmTimeout);
    clearTimeout(errorTimeout);
    refreshDrawerChrome();

    lastFocus = document.activeElement;
    drawerRoot.hidden = false;
    drawerRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    // Hide legacy mini-cart dropdown if open
    var mini = document.getElementById('header-cart');
    if (mini) $(mini).hide();

    requestAnimationFrame(function () {
      drawerRoot.classList.add('is-open');
    });
  }

  function closeDrawer(skipFocus) {
    drawerRoot.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    drawerRoot.setAttribute('aria-hidden', 'true');

    setTimeout(function () {
      drawerRoot.hidden = true;
      if (!skipFocus && lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, 300);
  }

  function showAdded(item, addedQty) {
    if (!item) {
      openDrawer();
      return;
    }
    openConfirm(item, addedQty);
  }

  function handleQtyClick(btn) {
    if (typeof CartJS === 'undefined') return;

    var itemEl = btn.closest('.cart-drawer__item');
    if (!itemEl) return;

    var line = parseInt(itemEl.getAttribute('data-cart-drawer-line'), 10);
    if (!line || line < 1) return;

    var action = btn.getAttribute('data-cart-drawer-qty');
    var qty = getLineQuantity(line);
    if (action === 'plus') qty += 1;
    else if (action === 'minus') qty -= 1;
    else return;

    if (qty < 1) {
      CartJS.removeItem(line, {
        complete: refreshDrawerChrome
      });
    } else {
      CartJS.updateItem(line, qty, {}, {
        complete: refreshDrawerChrome
      });
    }
  }

  function handleRemoveClick(btn) {
    if (typeof CartJS === 'undefined') return;
    var itemEl = btn.closest('.cart-drawer__item');
    if (!itemEl) return;
    var line = parseInt(itemEl.getAttribute('data-cart-drawer-line'), 10);
    if (!line || line < 1) return;
    CartJS.removeItem(line, {
      complete: refreshDrawerChrome
    });
  }

  function handleUpsellAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || typeof CartJS === 'undefined' || btn.classList.contains('is-added')) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    CartJS.addItem(variantId, 1, {}, {
      success: function () {
        btn.classList.remove('is-loading');
        markUpsellAdded(btn);
        window.setTimeout(function () {
          refreshDrawerChrome({ highlightVariantId: variantId });
        }, 420);
      },
      error: function (jqXHR) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        var errormsg = 'Unable to add to cart';
        try {
          errormsg = JSON.parse(jqXHR.responseText).description;
        } catch (e) {}
        if (theme.CartDrawer && theme.CartDrawer.showError) {
          theme.CartDrawer.showError(errormsg);
        }
      }
    });
  }

  // Events
  confirmRoot.addEventListener('click', function (e) {
    if (e.target.closest('[data-atc-confirm-close]')) {
      e.preventDefault();
      closeConfirm();
      return;
    }
    if (e.target.closest('[data-atc-confirm-view]')) {
      e.preventDefault();
      openDrawer();
    }
  });

  if (errorRoot) {
    errorRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-atc-error-close]')) {
        e.preventDefault();
        closeError();
      }
    });
  }

  drawerRoot.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-drawer-qty]');
    if (qtyBtn && drawerRoot.contains(qtyBtn)) {
      e.preventDefault();
      handleQtyClick(qtyBtn);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-drawer-remove]');
    if (removeBtn && drawerRoot.contains(removeBtn)) {
      e.preventDefault();
      handleRemoveClick(removeBtn);
      return;
    }

    var upsellBtn = e.target.closest('[data-cart-drawer-upsell-add]');
    if (upsellBtn && drawerRoot.contains(upsellBtn)) {
      e.preventDefault();
      handleUpsellAdd(upsellBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerRoot.classList.contains('is-open')) {
      closeDrawer();
    } else if (errorRoot && errorRoot.classList.contains('is-open')) {
      closeError();
    } else if (confirmRoot.classList.contains('is-open')) {
      closeConfirm();
    }
  });

  // Header bag → open drawer (capture so it wins over mini-cart toggle)
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.site-header__cart');
    if (!cartLink) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }, true);

  // Keep shipping / upsell / line items in sync with CartJS
  $(document).on('cart.requestComplete', function () {
    refreshDrawerChrome();
  });

  function boot() {
    seedCompareAtFromDom();
    refreshDrawerChrome();
  }

  if (window.CartJS && CartJS.cart) {
    boot();
  } else if (window.jQuery) {
    $(document).on('cart.ready', boot);
    $(function () {
      // CartJS.init also runs on ready; wait a tick so cart data exists.
      setTimeout(boot, 0);
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 0);
    });
  } else {
    setTimeout(boot, 0);
  }

  // Public API used by theme.js / quick-shop.js / ajaxfilter.js
  theme.CartDrawer = {
    showAdded: showAdded,
    showError: openError,
    open: openDrawer,
    close: closeDrawer,
    closeConfirm: closeConfirm,
    closeError: closeError,
    isEnabled: true
  };
})();
